/**
 * 价格/寻源
 * */
//采购寻源视图页
import sourceItemView from '@/page/sources/source-item/source-item-view';
import sourceSupList from '@/page/sources/source-item/source-sup-list';
import sourceApprovalList from '@/page/sources/source-item/source-approval-list';
import sourceList from '@/page/sources/source-sup/source-list';
import SourceSupItem from '@/page/sources/source-sup/source-sup-item';
import SourceSupOffer from '@/page/sources/source-sup/source-sup-offer.vue';
import SourceOfferView from '@/page/sources/source-sup/source-offer-view';
//寻源评分
import scoreList from '@/page/sources/source-score/score-list';
import scoreDetail from '@/page/sources/source-score/score-detail';
import scoringList from '@/page/sources/source-score/scoring-list';
import scoringSupList from '@/page/sources/source-score/scoring-sup-list';
import scoringSupDetail from '@/page/sources/source-score/scoring-sup-detail';
import auditingScoreList from '@/page/sources/source-score/auditing-score-list';
import auditingSupScore from '@/page/sources/source-score/auditing-sup-score';
import auditingScoreDetail from '@/page/sources/source-score/auditing-score-detail';
//比价单
import parityOffer from '@/page/sources/price-parity/parity-offer';
import parityList from '@/page/sources/price-parity/parity-list';
//市场价格数据源
import marketPriceList from '@/page/sources/market-price/market-price-list';
import marketPriceDetail from '@/page/sources/market-price/market-price-detail';
//价格主数据
import srmPriceLibraryView from '@/page/price-library/srm-price-library-view';
import erpPriceLibrary from '@/page/price-library/erp-price-library';
import erpPriceDetail from '@/page/price-library/erp-price-detail';
import priceApprovalList from '@/page/price-approval/price-approval-list';
export default [
  /**
   * 价格、寻源信息
   * */
  //寻源采购视图
  {
    path:'/sources/:id',
    component:sourceItemView,
    meta:{
      title:'寻源管理'
    }
  },
  {
    path:'/sources-sup-list/:id',
    component:sourceSupList,
    meta:{
      title:'供应商清单'
    }
  },
  {
    path:'/source-approval/list',
    component:sourceApprovalList,
    meta:{
      title:'待审核项目'
    }
  },
  // 寻源供应商视图
  {
    path:'/sup-sources-list/:status',
    component:sourceList,
    meta:{
      title:'寻源项目'
    }
  },
  {
    path:'/sources-sup/:id',
    component:SourceSupItem,
    meta:{
      title:'寻源管理'
    }
  },
  {
    path:'/sup-offer/:id',
    component:SourceSupOffer,
    meta:{
      title:'报价/投标'
    }
  },
  {
    path:'/view-offer/:id/:round/:supId',
    component:SourceOfferView,
    meta:{
      title:'报价/投标详情'
    }
  },
  //寻源评分
  {
    path:'/source-score/list',
    component:scoreList,
    meta:{
      title:'评分单'
    }
  },
  {
    path:'/source-score/view/:id',
    component:scoreDetail,
    meta:{
      title:'评分单详情'
    }
  },
  {
    path:'/source-scoring/list',
    component:scoringList,
    meta:{
      title:'待评分项目'
    }
  },
  {
    path:'/source-scoring/sup-list/:sourceId/:detailId',
    component:scoringSupList,
    meta:{
      title:'待评分项目详情'
    }
  },
  {
    path:'/source-scoring/sup-detail/:ratingId/:scoringId/:scoringDetailId',
    component:scoringSupDetail,
    meta:{
      title:'评分详情'
    }
  },
  {
    path:'/auditing-score/list',
    component:auditingScoreList,
    meta:{
      title:'待审核评分项目',
    }
  },
  {
    path:'/auditing-sup-score/:sourceId/:detailId',
    component:auditingSupScore,
    meta:{
      title:'待审核评分详情'
    }
  },
  {
    path:'/auditing-score/detail/:ratingId/:supId',
    component:auditingScoreDetail,
    meta:{
      title:'评分详情'
    }
  },
  //比价单管理
  {
    path:'/price-parity/list',
    component:parityList,
    meta:{
      title:'比价单'
    }
  },
  {
    path:'/parity-offer/:roundId',
    component:parityOffer,
    meta:{
      title:'报价详情'
    }
  },
  {
    path:'/parity-detail/:parityId',
    component:parityOffer,
    meta:{
      title:'比价单详情'
    }
  },
  //市场价格数据源
  {
    path:'/market-list',
    component:marketPriceList,
    meta:{
      title:'市场价格数据源'
    }
  },
  {
    path:'/market-detail/:id',
    component:marketPriceDetail,
    meta:{
      title:'市场价格数据源详情'
    }
  },
  {
    path: '/srm-price-view/:priceId',
    component: srmPriceLibraryView,
    meta: {
      title: 'srm价格库详情'
    }
  },
  {
    path: '/erp-price-query',
    component: erpPriceLibrary,
    meta: {
      title: '价格库'
    }
  },
  {
    path: '/erp-price-detail/:priceId',
    component: erpPriceDetail,
    meta: {
      title: 'erp价格详情'
    }
  },
  {
    path: '/price-approval-list',
    component: priceApprovalList,
    meta: {
      title: '价格表审批待办'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/source.js